module.exports = __webpack_public_path__ + "media/images/mobile/title_gray_q-013434148b17b1d0bb4a32093435c076.gif";